import * as Yup from "yup";
import { Board } from "../../../../reducers/uploadedBoard";
import { Title } from "../DashboardStyles";
import { Formik } from "formik";
import FormikFormLine from "../../../formik-form-components/FormikFormLine";
import ContainerFormButtons from "../../../component-search/PartDrawer/Inventory/PhysicalInventory/ContainerFormButtons";
import { useUpdateBoardNickname } from "../../../../utils/hooks/commonly-stored/uploaded-board/updates/board";
import { FormContainer } from "../../../../constants/Styles";

interface NicknameFormValues {
  internal_nickname: string;
}

const nicknameFormSchema = Yup.object().shape({
  internal_nickname: Yup.string().required("Nickname is required"),
});

export default function UpdateBoardNickName({
  board,
  closeModal,
}: {
  board: Board;
  closeModal: () => void;
}) {
  const { updateInternalNickname, updatingNickname } = useUpdateBoardNickname();
  const updateNickname = (values: NicknameFormValues) => {
    updateInternalNickname(board.id, values.internal_nickname);
    closeModal();
  };
  return (
    <>
      <Title>Update board nickname</Title>
      <Formik
        initialValues={{ internal_nickname: board.internal_nickname }}
        onSubmit={updateNickname}
        validationSchema={nicknameFormSchema}
      >
        {({ handleSubmit, isValid, dirty }) => {
          return (
            <FormContainer onSubmit={handleSubmit}>
              <FormikFormLine name="internal_nickname" label="Nickname" />
              <ContainerFormButtons
                onCancel={closeModal}
                loading={updatingNickname}
                isDisabled={!isValid || !dirty}
                onSubmit={handleSubmit}
              />
            </FormContainer>
          );
        }}
      </Formik>
    </>
  );
}
